var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "smtpServers" },
    [
      _c("div", { staticClass: "row pt-3 l-m-b-20 blocks" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center title-search col-9 pl-0" },
          [
            _c("h1", { staticClass: "w-25" }, [_vm._v("SMTP servers")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group search" }, [
              _c(
                "button",
                {
                  staticClass: "btn input-group-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.clearSearch }
                },
                [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.q,
                    expression: "q"
                  }
                ],
                staticClass: "form-control search-input",
                attrs: { type: "text", placeholder: "Search" },
                domProps: { value: _vm.q },
                on: {
                  keyup: function($event) {
                    _vm.searchText($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.q = $event.target.value
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-right pr-0" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", disabled: !_vm.companies },
              on: {
                click: function($event) {
                  _vm.showCreateModal = true
                }
              }
            },
            [_vm._v("\n        ADD\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mobile-hidden" }, [
          _c(
            "div",
            { staticClass: "col-12 d-flex align-items-center filters-field" },
            [
              _c("span", { staticClass: "pr-2" }, [_vm._v("Filters:")]),
              _vm._v(" "),
              _vm.filtersLoaded
                ? _c("span", [
                    _vm.filters.company
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter mr-1" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("company")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Company: " +
                                _vm._s(
                                  _vm.companies.find(function(el) {
                                    return el.id === _vm.filters.company
                                  }).name
                                )
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary add-filters",
                  on: {
                    click: function($event) {
                      _vm.showFilters = true
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus filter-icon" })]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.companies
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _vm.servers && _vm.servers.length
              ? _c(
                  "div",
                  { staticClass: "blocks" },
                  [
                    _vm._l(_vm.servers, function(server, index) {
                      return _c("SmtpServersBlock", {
                        key: index,
                        attrs: { companies: _vm.companies, server: server },
                        on: {
                          "update:server": function($event) {
                            server = $event
                          },
                          editServer: function($event) {
                            _vm.editSmtpServer(server)
                          }
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row blocks" },
                      [
                        _vm.meta.total
                          ? _c(
                              "div",
                              {
                                staticClass: "col-sm-6 mb-1 text-black-50 pl-0"
                              },
                              [
                                _vm._v(
                                  "\n          Showing " +
                                    _vm._s(_vm.meta.from) +
                                    " - " +
                                    _vm._s(_vm.meta.to) +
                                    " of " +
                                    _vm._s(_vm.meta.total) +
                                    "\n        "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          staticClass: "col-sm-6 mb-1 pr-0",
                          attrs: {
                            "change-page": _vm.changePage,
                            meta: _vm.meta
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _c("div", [
                  _c("div", { staticClass: "text-center" }, [
                    _vm._v(
                      "You don’t have any SMTP servers added. Click the button at the top to create and connect to your company."
                    )
                  ])
                ])
          ],
      _vm._v(" "),
      _vm.showCreateModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Add new smtp server")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 mb-3" },
                          [
                            _c("div", { staticClass: "title-text" }, [
                              _vm._v("Company")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-wrap h-auto" },
                              [
                                _c("label", { staticClass: "m-label" }, [
                                  _vm._v("Company")
                                ]),
                                _vm._v(" "),
                                _c("simple-select", {
                                  attrs: {
                                    options: _vm.filteredCompanies,
                                    placeholder: "Select Company"
                                  },
                                  model: {
                                    value: _vm.companyId,
                                    callback: function($$v) {
                                      _vm.companyId = $$v
                                    },
                                    expression: "companyId"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "company_id" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "title-text" }, [
                              _vm._v("Credentials")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Host")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.mail_host,
                                    expression: "company.mail_host"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", autocomplete: "nope" },
                                domProps: { value: _vm.company.mail_host },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.company,
                                      "mail_host",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "mail_host" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Port")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.mail_port,
                                    expression: "company.mail_port"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { autocomplete: "nope1", type: "text" },
                                domProps: { value: _vm.company.mail_port },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.company,
                                      "mail_port",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "mail_port" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Username")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.mail_username,
                                    expression: "company.mail_username"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { autocomplete: "nope2", type: "text" },
                                domProps: { value: _vm.company.mail_username },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.company,
                                      "mail_username",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "mail_username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Password")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.mail_password,
                                    expression: "company.mail_password"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "new-password",
                                  type: "password"
                                },
                                domProps: { value: _vm.company.mail_password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.company,
                                      "mail_password",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "mail_password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Encryption")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.mail_encryption,
                                    expression: "company.mail_encryption"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { autocomplete: "nope4", type: "text" },
                                domProps: {
                                  value: _vm.company.mail_encryption
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.company,
                                      "mail_encryption",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "mail_encryption"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 col-sm-12 instructions-text" },
                      [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "Settings explained below are related to Gmail SMTP settings for your account."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "If you wish to send from your own SMTP server, please contact your administrator for details how to set it up."
                            )
                          ])
                        ]),
                        _vm._v(
                          "\n\n            1. On your google account, allow access to less secure apps here "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://myaccount.google.com/lesssecureapps",
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "https://myaccount.google.com/lesssecureapps"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n\n            2. Enable 2 step verification on your google account "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n            3. Go to mod24 SMTP servers and create a new one "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n            4. Select a company you wish to send emails from your gmail account "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n            5. Use smtp.gmail.com as a host, port 465, encryption as SSL or port 587/STARTTLS "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n            6. Username will be the email address you are using for this company. If you are using an alias for the company please enter that instead of your primary account email"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n            7. Password that provides access should be generated on your google account: "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl-3" }, [
                          _vm._v(
                            "- On your google account go to Security > Signing in to Google > App passwords "
                          ),
                          _c("br")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl-3" }, [
                          _vm._v(
                            "- Add a new app password by choosing “Other” and generating it "
                          ),
                          _c("br")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pl-3" }, [
                          _vm._v(
                            "- Copy the generated password so you can grant access on mod24 "
                          ),
                          _c("br")
                        ]),
                        _vm._v("\n\n            11. Create "),
                        _c("br")
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "button",
                            disabled: _vm.companyId === null
                          },
                          on: { click: _vm.saveSmtpServer }
                        },
                        [_vm._v("\n            Create\n          ")]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Edit SMTP server ")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12 col-sm-12" }, [
                      _c("div", { staticClass: "row mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 mb-3" },
                          [
                            _c("div", { staticClass: "title-text" }, [
                              _vm._v("Company")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Company")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.companyName,
                                    expression: "companyName"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "nope5",
                                  type: "text",
                                  disabled: true
                                },
                                domProps: { value: _vm.companyName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.companyName = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "company_id" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "title-text" }, [
                              _vm._v("Credentials")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Host")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editedSmtpServer.mail_host,
                                    expression: "editedSmtpServer.mail_host"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", autocomplete: "nope6" },
                                domProps: {
                                  value: _vm.editedSmtpServer.mail_host
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editedSmtpServer,
                                      "mail_host",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "mail_host" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Port")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editedSmtpServer.mail_port,
                                    expression: "editedSmtpServer.mail_port"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { autocomplete: "nope7", type: "text" },
                                domProps: {
                                  value: _vm.editedSmtpServer.mail_port
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editedSmtpServer,
                                      "mail_port",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "mail_port" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Username")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editedSmtpServer.mail_username,
                                    expression: "editedSmtpServer.mail_username"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { autocomplete: "nope8", type: "text" },
                                domProps: {
                                  value: _vm.editedSmtpServer.mail_username
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editedSmtpServer,
                                      "mail_username",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "mail_username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Password")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editedSmtpServer.mail_password,
                                    expression: "editedSmtpServer.mail_password"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "new-password",
                                  type: "password"
                                },
                                domProps: {
                                  value: _vm.editedSmtpServer.mail_password
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editedSmtpServer,
                                      "mail_password",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "mail_password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", { staticClass: "m-label" }, [
                                _vm._v("Encryption")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.editedSmtpServer.mail_encryption,
                                    expression:
                                      "editedSmtpServer.mail_encryption"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { autocomplete: "nope9", type: "text" },
                                domProps: {
                                  value: _vm.editedSmtpServer.mail_encryption
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.editedSmtpServer,
                                      "mail_encryption",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "mail_encryption"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("div", { staticClass: "row mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "col d-flex justify-content-between" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger deleteBtn",
                            attrs: { type: "button" },
                            on: { click: _vm.deleteSmtpServer }
                          },
                          [_vm._v("\n            Delete\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: { click: _vm.updateSmtpServer }
                          },
                          [_vm._v("\n            Save\n          ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "filters-side-modal flex flex-column justify-content-between"
                      },
                      [
                        _c("div", { staticClass: "filters-container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function($event) {
                                  _vm.showFilters = !_vm.showFilters
                                }
                              }
                            },
                            [
                              _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                                _c("span", { staticClass: "btn btn-back" }),
                                _vm._v("Add Filter")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", [
                              _vm._v(
                                "\n              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n            "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "l-bg-white" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("div", { staticClass: "row filters" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "select-wrap" },
                                      [
                                        _c("label", [_vm._v("Company")]),
                                        _vm._v(" "),
                                        _c("simple-select", {
                                          attrs: {
                                            options: _vm.companies,
                                            placeholder: "Select Company"
                                          },
                                          on: { input: _vm.search },
                                          model: {
                                            value: _vm.filters.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "company",
                                                $$v
                                              )
                                            },
                                            expression: "filters.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm.filters.company
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fd6cffa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd6cffa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Mailing/SmtpServers.vue
// module id = null
// module chunks = 